import { isEmpty } from 'lodash';
import { createReducer } from '../../../../../../helpers/reducer';
import actions from './actions';
import { t } from '../../../../../../i18n';

const getInitialField = fieldName => ({
  value: null,
  error: null,
  name: fieldName,
  touched: false,
});

const initState = {
  loading: false,
  isModalVisible: false,
  editForm: {
    talent: getInitialField('talent'),
    positions: getInitialField('positions'),
  },
  talents: undefined,
  totalCount: undefined,
};

function validate(attr, value) {
  let error = '';

  if (attr === 'position') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.units.unit.my_team.add_talent_modal.position_field_label'),
      });
    }
  }

  return error;
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onClearStore() {
  return {
    ...initState,
    editForm: {
      talent: getInitialField('talent'),
      positions: getInitialField('positions'),
    },
  };
}

function onLoadTalentRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadTalentSuccess(state, { payload }) {
  const { records, totalCount } = payload;

  return {
    ...state,
    talents: records,
    totalCount,
    loading: false,
  };
}

function onLoadTalentError(state) {
  return {
    ...state,
    loading: false,
  };
}

function onAddTalentToMyTeamRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onAddTalentToMyTeamSuccess(state) {
  return {
    ...state,
    loading: false,
  };
}

function onAddTalentToMyTeamError(state) {
  return {
    ...state,
    loading: false,
  };
}

function onShowModal(state) {
  return {
    ...state,
    isModalVisible: true,
  };
}

function onCloseModal(state) {
  return {
    ...state,
    isModalVisible: false,
  };
}

export default createReducer(initState, {
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.LOAD_TALENT_REQUEST]: onLoadTalentRequest,
  [actions.LOAD_TALENT_SUCCESS]: onLoadTalentSuccess,
  [actions.LOAD_TALENT_ERROR]: onLoadTalentError,
  [actions.ADD_TALENT_TO_MY_TEAM_REQUEST]: onAddTalentToMyTeamRequest,
  [actions.ADD_TALENT_TO_MY_TEAM_SUCCESS]: onAddTalentToMyTeamSuccess,
  [actions.ADD_TALENT_TO_MY_TEAM_ERROR]: onAddTalentToMyTeamError,
  [actions.SHOW_MODAL]: onShowModal,
  [actions.CLOSE_MODAL]: onCloseModal,
  [actions.CLEAR_STORE]: onClearStore,
});
